import { createContext } from 'react';

import { CompanyPosition } from '@vyce/core/src/types';

// The single source of truth about what the current user may do. Core can't read
// an app's Redux store, so each app computes this and provides it; core reads it
// through usePermissions().
interface PermissionContextValue {
  /** state.helper.selectedPosition in pay-app. Undefined in legend-app. */
  position?: CompanyPosition;
  /** Legend staff hold no position in the customer's company but may do anything. */
  isInternalAdmin: boolean;
  /**
   * False until /users/me/basic has resolved. Every predicate answers `false`
   * while it is false, so a route guard must treat this as "wait", not "deny".
   */
  ready: boolean;
}

export const PermissionContext = createContext<PermissionContextValue>({
  isInternalAdmin: false,
  ready: false,
});

export const PermissionProvider = PermissionContext.Provider;
